import React, { useState, useRef, useEffect } from 'react';
import SearchAutoCompleteContainer from '@jetshop/ui/Search/SearchAutoCompleteContainer';
import { styled } from "linaria/react";
import AutocompleteQuery from '../AutocompleteQuery.gql';
import SearchResult from './SearchResult';
import { ReactComponent as SearchIcon } from '../../../../svg/fa/search.svg';
import SearchInputNew from './SearchInputNew';

const SearchContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.5rem 1rem 1rem 1rem;
  margin-top: 0.5rem;
`;

const SearchWrapper = styled('div')`
  width: 100%;
  max-width: 550px;
  height: 32px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: auto auto;

  .icon {
    grid-area: 1 / 8 / 2 / 9;
    width: 16px;
    z-index: 2;
    align-self: center;
    justify-self: flex-end;
    margin-right: 10px;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }
`;

const SearchNew = ({
  ...searchFieldProps
}) => {
  const [searchOpen, setSearchOpen] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const searchResultRef = useRef(null);
  
  // Close search result when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is on search icon or search input
      const isSearchIcon = event.target.closest('.icon');
      const isSearchInput = event.target.closest('#search-input-mobile');
      
      if (searchResultRef.current && 
          !searchResultRef.current.contains(event.target) && 
          !isSearchIcon && 
          !isSearchInput) {
        setSearchOpen(false);
        setInputValue('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
  <SearchAutoCompleteContainer
    autocompleteQuery={AutocompleteQuery}
    {...searchFieldProps}
    onSubmit={() => {
      setSearchOpen(false);
      setInputValue('');
    }}
    onCancel={() => {}}
  >
    {({
      getInputProps,
      getFlyoutProps,
      getCancelProps,
      inputRef,
      updateFocus,
      triggerSearch,
      ...rest
    }) => {

      return (
        <SearchContainer>
          <SearchWrapper>
            <SearchIcon 
              className='icon' 
              onClick={() => {
                if (inputValue.trim()) {
                  triggerSearch();
                  setSearchOpen(false);
                }
              }}
            />
            <SearchInputNew
              gridArea='1 / 1 / 2 / 9'
              getInputProps={getInputProps}
              setSearchOpen={setSearchOpen}
              inputValue={inputValue}
              setInputValue={setInputValue}
              triggerSearch={triggerSearch}
              {...rest}
            />
            {rest.term.length > 0 && searchOpen && (
              <div ref={ searchResultRef } >
                <SearchResult
                  term={rest.term}
                  triggerSearch={triggerSearch}
                  setSearchOpen={setSearchOpen}
                  {...rest}
                />
              </div>
            )}
          </SearchWrapper>
        </SearchContainer>
      );
    }}
  </SearchAutoCompleteContainer>
  );
};

export default SearchNew;
